module.exports = __webpack_public_path__ + "static/circuitry-background-43a49b6d89349ae47d76e22be82337b4.png";